module.exports = __webpack_public_path__ + "static/media/5.035e3f2d.mp3";